import { ConfigObj, Ajax, DomHelpers } from '../utils'

const _defaultOpts = {
  messageSuccess: 'Ok {{campaignMessage}} {{campaignEndDate}}',
  messageOk: 'Ok',
  messageInvalid: 'Invalid',
  messageError: 'System error',
  messageExpired: 'Expired',
  messageRedeemed: 'Redeemed',
  messageInvalidField: 'Invalid fields',
  expireOldCodes: false
}

const API_URI = '/umbraco/api/referralcode/validate'

const SELECTORS = {
  LOADING: 'ps-loading',
  LINK: 'ps-input-button',
  SUCCESS_MESSAGE: 'ps-referral-code__success-message'
}

const VALIDATION_STATUS = {
  OK: 'Ok',
  SUCCESS: 'Success',
  INVALID: 'Invalid',
  REDEEMED: 'Redeemed',
  EXPIRED: 'Expired',
  ERROR: 'Error',
  INVALID_FIELDS: 'InvalidField',
}

export default class ReferralCode {

  constructor($el, opts) {
    this.$el = $el
    this.opts = ConfigObj.merge(_defaultOpts, opts)
  }

  /**
   * initialise the class
  */
  init() {
    this.$field = this.$el.querySelector('input')
    this.$button = this.$el.querySelector(`.${SELECTORS.LINK}`)

    this.addEventListeners()
  }

  /**
   * Click event delegation
   * @param {Object} e - Event data
   */
  onClick(e) {
    DomHelpers.delegateEvent(e, `.${SELECTORS.LINK}`, this.applyCode.bind(this))
  }

  /**
   * Keyup event delegation
   * @param {Object} e - Event data
   */
  onKeyup(e) {
    const $target = e.target

    if (/input/i.test($target.nodeName))
      $target.classList[this.inputIsValid() ? 'remove' : 'add']('input-validation-error')
  }

  /**
   * Sends and stores the user defined referral code
  */
  applyCode() {
    DomHelpers.destroyElement(this.$el.querySelector(`.${SELECTORS.SUCCESS_MESSAGE}`))

    if (this.inputIsValid() == false) {
      this.setFieldValidation()
      this.showValidationMessage(VALIDATION_STATUS.INVALID_FIELDS)
      return
    }

    // Return old codes as expired
    if (this.opts.expireOldCodes == true && /[-_]+/g.test(this.$field.value) == true) {
      return this.showValidationMessage(VALIDATION_STATUS.EXPIRED)
    }

    Ajax.request(API_URI, {
      queryParams: {
        code: this.$field.value
      },
      onLoad: this.onAjaxResponse.bind(this),
      onError: this.onAjaxError.bind(this)
    })

    this.$button.classList.add(SELECTORS.LOADING)
  }

  /**
   * Ajax response handler
   * @param {Object} response
   */
  onAjaxResponse(response = {code: '', response: ''}) {
    this.$button.classList.remove(SELECTORS.LOADING)

    if (response.result == VALIDATION_STATUS.OK && response.campaign !== null) return this.showSuccessMessage(response.campaign.message, response.campaign.to)
    if (response.result == VALIDATION_STATUS.OK) return this.showValidationMessage(VALIDATION_STATUS.OK)
    if (response.result == VALIDATION_STATUS.INVALID) return this.showValidationMessage(VALIDATION_STATUS.INVALID)
    if (response.result == VALIDATION_STATUS.REDEEMED) return this.showValidationMessage(VALIDATION_STATUS.REDEEMED)
    if (response.result == VALIDATION_STATUS.EXPIRED) return this.showValidationMessage(VALIDATION_STATUS.EXPIRED)
  }

  /**
   * Ajax error handler
   * @param {String} status - server error message
   */
  onAjaxError() {
    this.$button.classList.remove(SELECTORS.LOADING)
    this.showValidationMessage(VALIDATION_STATUS.ERROR)
  }

  /**
   * Validates the fields input value
   * @returns {Boolean}
   */
  inputIsValid() {
    return /^\d{4}[\da-zA-Z]{2}|\d{4}([-_])\d{1,2}\1\d{1,6}$/.test(this.$field.value)
  }

  /**
   * Mimics jQuery validation to set/unset field validation style
   * @param {Boolean} forceInvalid
   */
  setFieldValidation(forceInvalid = false) {
    const isValid = forceInvalid ? false : this.inputIsValid()

    if (isValid) this.$field.classList.add('input-validation-error')
  }

  generateSuccessMessage(message = '[CAMPAIGN_MESSAGE]', endDate = '[CAMPAIGN_END_DATE]') {
    return `<div class="${SELECTORS.SUCCESS_MESSAGE}">
              <div><b>Congratulations!</b></div>
              <div>${this.getInterpolatedMessage({ campaignMessage: message, campaignEndDate: endDate })}</div>
            </div>`
  }

  getInterpolatedMessage(messageParts = { campaignMessage: '', campaignEndDate: '' }) {
    let message = this.opts.messageSuccess

    Object.keys(messageParts).forEach(key => {
      message = message.replace(RegExp(`{{${key}}}`, 'gi'), messageParts[key])
    })

    return message
  }

  /**
   * Sets the validation message content and style then displays it
   * @param {any} status
   */
  showValidationMessage(status) {
    this.removeValidationMessage()
    const classSuffix = status == VALIDATION_STATUS.OK
      ? 'success'
      : 'error'

    const $statusMessage = document.createElement('span')

    if (status != VALIDATION_STATUS.SUCCESS) {
      $statusMessage.classList.add(`field-validation-${classSuffix}`)
      $statusMessage.textContent = this.opts[`message${status}`]
    } else {
      $statusMessage.innerHTML = this.opts[`messageSuccessHtml`]
    }

    this.$el.appendChild($statusMessage)

    if (status != VALIDATION_STATUS.OK || status != VALIDATION_STATUS.SUCCESS) this.setFieldValidation(true)
  }

  showSuccessMessage(message = '[CAMPAIGN_MESSAGE]', endDate = '[CAMPAIGN_END_DATE]') {
    let date = new Date(endDate)
    if ( isNaN(date.getDate()) ) date = new Date() // Shitty fallback, need to revise

    const day = `${date.getDate()}`.padStart(2, 0)
    const month = `${date.getMonth() + 1}`.padStart(2, 0)

    endDate = `<b>${day}/${month}/${date.getFullYear()}</b>`
    message = `${message}`

    this.opts.messageSuccessHtml = this.generateSuccessMessage(message, endDate)

    this.showValidationMessage(VALIDATION_STATUS.SUCCESS)
  }

  removeValidationMessage() {
    DomHelpers.destroyElement(this.$el.querySelector('[class^="field-validation"]'))
  }

  /**
   * Adds event listeners
  */
  addEventListeners() {
    this.$el.addEventListener('click', this.onClick.bind(this))
    this.$el.addEventListener('keyup', this.onKeyup.bind(this))
    this.$el.addEventListener('change', this.removeValidationMessage.bind(this))
  }
}



// WEBPACK FOOTER //
// ./js/modules/ReferralCode.js